import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  cookingStoryPageCategories,
  groceryCategoryList,
  kitchenItem,
  KitchenItemInCategory,
  kitchenSearchItem,
} from 'src/app/core/model/api-response/cooking-story-model';
import { FoodModel } from 'src/app/core/model/object/diet-food-model';
import { CookingStoryGroceryService } from 'src/app/data/repository/cooking-story/cooking-story-grocery.service';
import { CookingStoryKitchenDataService } from 'src/app/data/repository/cooking-story/cooking-story-kitchen-data.service';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';
import Num2persian from 'num2persian';
import { DateHelper } from 'src/app/utils/date-helper';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { KitchenSearchEditComponent } from './kitchen-search/kitchen-search-edit/kitchen-search-edit.component';
import { foodUnitRatioArraySample } from 'src/app/core/model/api-response/persoanl-response-model';
import { Subscription } from 'rxjs';
import { KitcchenQuickAddComponent } from './kitcchen-quick-add/kitcchen-quick-add.component';
import { CookingStoryGroceryApiService } from 'src/app/data/repository/cooking-story/cooking-story-kitchen-api.service';
import { AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';

@Component({
  selector: 'app-kitchen',
  templateUrl: './kitchen.component.html',
  styleUrls: ['./kitchen.component.scss'],
})
export class KitchenComponent implements OnInit, OnDestroy {
  kitchenItems: KitchenItemInCategory[] = [];
  groceryCategoryList: groceryCategoryList[];
  unitlist;
  subscriptions: Subscription[] = [];
  suggestPost: cookingStoryPageCategories;
  isReady: boolean = false;
  options: AnimationOptions = {
    path: '/assets/animations/emptyList.json',
    loop: false,
  };
  showLottie: boolean = false;
  isSelecting = false;
  selectedItem: string[] = [];
  constructor(
    private recipeService: RecipeService,
    private cookingStoryGroceryService: CookingStoryGroceryService,
    private cookingStoryKitchenDataService: CookingStoryKitchenDataService,
    private dateHelper: DateHelper,
    private matBottomSheet: MatBottomSheet,
    private groceryApiService: CookingStoryGroceryApiService
  ) {}

  async ngOnInit() {
    await this.initail();
    const sub = this.cookingStoryKitchenDataService.update.subscribe(
      (update) => {
        if (update) {
          this.update();
        }
      }
    );
    const selecting =
      this.cookingStoryGroceryService.toggleAllKitchenItems.subscribe(
        (move) => {
          if (move) {
            this.selectedItem = [];

            this.selectedItem = this.cookingStoryKitchenDataService
              .getItems()
              .map((item) => item.id);
            this.isSelecting = true;
          } else {
            this.selectedItem = [];
            this.isSelecting = false;
          }
        }
      );
    const newQA = this.cookingStoryKitchenDataService.getNewQuickAdd.subscribe(
      (data) => {
        this.getItemsFromServie();
        let l = 1;
        this.kitchenItems.map((data) => {
          if (data.foods.length > 0) {
            l += 1;
          }
        });
        if (l == 0) {
          this.showLottie = true;
        } else {
          this.showLottie = false;
        }
      }
    );
    const refetch = this.cookingStoryKitchenDataService.refetch.subscribe(
      (data) => {
        this.initail();
      }
    );
    this.subscriptions.push(sub, refetch, newQA, selecting);
  }
  animationCreated(animationItem: AnimationItem): void {}
  checkSelect(id: string): boolean {
    let item = this.selectedItem.find((x) => x == id);
    if (!item) {
      return true;
    } else {
      return false;
    }
  }
  toggleSelect(id: string) {
    const ids = this.selectedItem.find((x) => x == id);
    if (ids) {
      this.selectedItem = this.selectedItem.filter((x) => x !== id);
    } else {
      this.selectedItem.push(id);
    }
    if (this.selectedItem.length == 0) {
      this.isSelecting = false;
    }
  }
  removeAll() {
    if (this.selectedItem.length > 0) {
      this.cookingStoryKitchenDataService.deleteSelectedItems(
        this.selectedItem
      );

      this.cookingStoryGroceryService.kitchenDeslecting.next();
      this.selectedItem = [];
    }
  }
  hadComment(food: kitchenItem) {
    const is =
      food?.description &&
      this.cookingStoryKitchenDataService.getItem(food._id)?.description !== ''
        ? true
        : false;
    return is;
  }
  async initail() {
    this.cookingStoryKitchenDataService.clearKitchenItems();
    this.unitlist = await this.cookingStoryKitchenDataService.getUnitList();
    this.cookingStoryGroceryService
      .getGroceryCategoryListData()
      .then((data) => {
        this.groceryCategoryList = data
          .getData()
          .getGroceryCategoryRespoce().list;
        this.cookingStoryKitchenDataService.saveGroceryCategory(
          this.groceryCategoryList
        );
        this.cookingStoryGroceryService
          .getKitchenHomeData()
          .then(async (data) => {
            if (
              data.getData().getKitchenHomeItemResponce().kitchen.length == 0
            ) {
              this.showLottie = true;
            } else {
              this.showLottie = false;
            }
            this.kitchenItems =
              await this.cookingStoryKitchenDataService.addKitchenItems(
                data.getData().getKitchenHomeItemResponce().kitchen
              );
            this.kitchenItems.map((item) => {
              item.foods.map((selectedItem) => {
                if (selectedItem.quickAdd) {
                  const data = new kitchenSearchItem(
                    null,
                    selectedItem.quickAdd,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    true,
                    selectedItem._id
                  );
                  this.cookingStoryKitchenDataService.JustaddItem(data);
                } else {
                  const unit = this.unitlist.filter((d) => {
                    return selectedItem.unit == d._id;
                  })[0];

                  let unitDescription;
                  if (selectedItem.unit && !selectedItem.unitDescription) {
                    unitDescription = unit.name;
                  } else {
                    unitDescription = selectedItem.unitDescription;
                  }
                  const data = new kitchenSearchItem(
                    (selectedItem.food as FoodModel)._id,
                    null,
                    parseInt(selectedItem.amount as any),
                    selectedItem.unit,
                    unitDescription,
                    selectedItem.description,
                    selectedItem.expireDate as any,
                    (selectedItem.food as FoodModel).name,
                    (selectedItem.food as FoodModel).foodUnitRatioArray as any,
                    true,
                    selectedItem._id
                  );

                  this.cookingStoryKitchenDataService.JustaddItem(data);
                }
              });
            });
            this.groceryApiService.getkitchenSuggestion().then((data) => {
              if (data.isSuccess()) {
                this.suggestPost = data
                  .getData()
                  .getkitchenSuggestion().kitchen;
                this.isReady = true;
              }
            });
          });
      });
  }
  showCategory(type: string, name: string) {
    this.recipeService.goToCategory(this.suggestPost._id, type, name);
  }
  async update() {
    this.kitchenItems =
      await this.cookingStoryKitchenDataService.getupdateListItem(
        this.kitchenItems
      );
    let l = 0;
    this.kitchenItems.map((data) => {
      if (data.foods.length > 0) {
        l += 1;
      }
    });
    if (l == 0) {
      this.showLottie = true;
    } else {
      this.showLottie = false;
    }
  }
  goTosearch() {
    this.recipeService.goToKitchenSearch();
  }
  async getItemsFromServie() {
    this.kitchenItems =
      await this.cookingStoryKitchenDataService.getAllKitchenItemInCategory();
    let l = 0;
    this.kitchenItems.map((data) => {
      if (data.foods.length > 0) {
        l += 1;
      }
    });
    if (l == 0) {
      this.showLottie = true;
    } else {
      this.showLottie = false;
    }
  }
  getFoodName(food: kitchenItem) {
    if (food.quickAdd && food.quickAdd !== '') {
      return food.quickAdd;
    }
    const amount = food.amount && food.amount > 0 ? food.amount : '';
    const foodName = (food.food as FoodModel)?.name;
    let unitName = food.unitDescription;
    if (
      !food.unitDescription ||
      food.unitDescription == '' ||
      food.amount == 0 ||
      !food.amount
    ) {
      unitName = ' ';
    }

    return amount + ' ' + unitName + ' ' + foodName;
  }

  getFoodEXP(food: kitchenItem) {
    if (food.expireDate && food.expireDate !== 0) {
      const date = new Date(food.expireDate);
      return '‌انقضا: ' + ' ' + this.dateHelper.getPersianBirthdayFormat(date);
    }
    return '';
  }
  openEditFood(food: kitchenItem) {
    this.cookingStoryKitchenDataService.changeType('edit');
    const newUnit = new foodUnitRatioArraySample(
      1,
      'nothing',
      'nothing',
      '',
      ''
    );
    this.cookingStoryKitchenDataService.clearUnsaved();
    const ids = (food.food as FoodModel).foodUnitRatioArray.map((unit) =>
      typeof unit.unitId == 'string' ? (unit.unitId as string) : null
    );
    if (!ids.includes(newUnit._id)) {
      (food.food as FoodModel).foodUnitRatioArray.push(newUnit as any);
    }

    const date =
      food.expireDate && food.expireDate > 0 ? new Date(food.expireDate) : null;
    const amount =
      food.unit && parseInt(food.unit) > 0 ? parseInt(food.unit) : null;
    const data = new kitchenSearchItem(
      (food.food as FoodModel).id,
      null,
      amount,
      food.unit,
      food.unitDescription,
      food.description,
      date,
      (food.food as FoodModel).name,
      (food.food as FoodModel).foodUnitRatioArray as any,
      true,
      food._id
    );

    const bottomSheetRef = this.matBottomSheet.open(
      KitchenSearchEditComponent,
      {
        panelClass: 'custom-bottomsheet-container',
        data: { food: data, id: food._id },
      }
    );
    const sub = bottomSheetRef
      .afterDismissed()
      .subscribe((dataFromChild) => {});
    this.subscriptions.push(sub);
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
  openQuickAdd() {
    this.cookingStoryKitchenDataService.changeType('search');
    this.cookingStoryKitchenDataService.changeActiveItem(null);
    const bottomSheetRef = this.matBottomSheet.open(KitcchenQuickAddComponent, {
      panelClass: 'custom-bottomsheet-container',
    });
    const sub = bottomSheetRef
      .afterDismissed()
      .subscribe((dataFromChild) => {});
    this.subscriptions.push(sub);
  }
  async openQuickEditFood(id) {
    let selectedItem = await this.kitchenItems.map((d) => {
      return d.foods.find((x) => {
        return x._id == id;
      });
    })[0];

    this.cookingStoryKitchenDataService.changeType('edit');

    const kitchenItem = new kitchenSearchItem(
      null,
      selectedItem.quickAdd,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      false,
      selectedItem._id
    );

    const data = { item: kitchenItem, id: selectedItem._id };
    const bottomSheetRef = this.matBottomSheet.open(KitcchenQuickAddComponent, {
      panelClass: 'custom-bottomsheet-container',
      data,
    });
    const sub = bottomSheetRef.backdropClick().subscribe((dataFromChild) => {});
    this.subscriptions.push(sub);
  }
  gArr(l: number) {
    return new Array(l);
  }
}
